module.exports = __webpack_public_path__ + "media/images/banner/becos/becos-tj-banner-5d0b814ddc0d49de3a597acd6a0147bd.jpg";